import React, { useEffect } from "react";

// Drain Sights — GoHighLevel review survey embed.
// The survey is fully managed by GoHighLevel; we only render the iframe.
// The companion script (`form_embed.js`) is already loaded once globally in
// `public/index.html` and auto-resizes the iframe (scrolling="no") via
// postMessage based on the survey's content height.
const SURVEY_ID = "cnF3EMLYVEv9pnBcx5p1";
const SURVEY_SRC = `https://link.reviewpresence.com/widget/survey/${SURVEY_ID}`;
// Fallback height so the survey shows before the GHL script resizes it. Kept
// modest so the short first step (star rating) doesn't leave a large gap — the
// GHL script grows the iframe for later steps (written feedback, etc.).
const INITIAL_HEIGHT = 440;
const REINIT_DELAY_MS = 600;

export default function ReviewSurvey() {
  // If the GHL script is already loaded, ask it to (re-)initialise the iframe
  // React just mounted — otherwise a client-side navigation can leave it
  // un-resized.
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const reinit = () => {
      try {
        if (window.LeadConnector && typeof window.LeadConnector.initIframe === "function") {
          window.LeadConnector.initIframe();
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.debug("ReviewSurvey: GHL initIframe not ready yet, will retry.", error);
        }
      }
    };
    reinit();
    const timer = setTimeout(reinit, REINIT_DELAY_MS);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="relative bg-white rounded-2xl shadow-[0_20px_50px_rgba(26,29,33,0.12)] border border-slate-200 p-2 sm:p-3"
      data-testid="review-survey"
      data-ghl-embed="true"
    >
      <div className="rounded-xl overflow-hidden" data-testid="review-survey-iframe-wrap">
        <iframe
          title="Leave Drain Sights a review"
          src={SURVEY_SRC}
          id={SURVEY_ID}
          scrolling="no"
          style={{ width: "100%", minHeight: `${INITIAL_HEIGHT}px`, border: "none", display: "block" }}
        />
      </div>
    </div>
  );
}
